import React, { useContext } from "react";
import { RouteComponentProps } from "react-router";
import { Button } from "antd";
import { HomeFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { IEmptyObject } from "@Components/shared/types";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";

import PageHelmet from "@Components/shared/PageHelmet";

import "@Styles/pages/404page.scss";

type Props = RouteComponentProps<IEmptyObject>;

const NotFoundPage: React.FC<Props> = () => {
    const { ui: uiState } = useContext(MainContext);
    const isDesktop = uiState.mode === ViewMode.desktop;
    const textColor = isDesktop ? { color: "black" } : { color: "white" };
    return (
        <div
            className="page-404"
            style={isDesktop ? { display: "flex", alignItems: "center", justifyContent: "center" } : null}
        >
            <>
                <PageHelmet name={"Page Not Found"} />

                <div className={"page-info"}>
                    <h2 style={textColor}>404</h2>
                    <p style={textColor}>We couldn’t find the page you're looking for</p>
                    <div>
                        <Link to="/">
                            <Button type="primary" size="large" icon={<HomeFilled />}>
                                Back home
                            </Button>
                        </Link>
                    </div>
                </div>
            </>
        </div>
    );
};

export default NotFoundPage;
